import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class OperationTimeService {
  currentOperationTime: Observable<any>;
  private selectionState = new BehaviorSubject<any>(0);

  constructor() {
    this.currentOperationTime = this.selectionState.asObservable();
  }

  changeOption(option: any) {
    this.selectionState.next(option);
  }
}
